export enum PlatformID {
    ALTERPAY = 'ALTERPAY',
    AVODAPAY = 'AVODAPAY',
    BANKWIRETRANSFER = 'BANKWIRETRANSFER',
    BIC = 'BIC',
    BIC_CN = 'BIC_CN',
    BIC_CN_RPN = 'BIC_CN_RPN',
    BITWALLET = 'BITWALLET',
    BPAY = 'Bpay',
    BPAY_FCS = 'Bpay_FCS',
    BRG_EIG_CYSEC_CC = 'BRG_EIG_CYSEC_CC',
    BRG_FCS_BEETELLER = 'BRG_FCS_BEETELLER',
    BRG_HAYVN = 'BRG_HAYVN',
    BRG_INT = 'BRG_INT',
    BRIDGER_H2P = 'BRG_H2P',
    BRIDGER_PAY = 'BRG',
    BRIDGER_WORLDPAY = 'BRG_CC',
    CREDIT_CARD = 'CREDIT_CARD',
    CHINA_APM = 'CHINA_APM',
    CUP = 'CUP',
    DIRECT_CRYPTO = 'DIRECTCRYPTO',
    ECHELONPAY_FCS = 'ECHELONPAY_FCS',
    EXIMBAY = 'BRG_FCS_CC',
    FASAPAY = 'FASAPAY',
    FAT = 'FAT',
    INDO = 'INDO',
    INDO_VFSC = 'INDO_VFSC',
    LatinBank = 'BKAL',
    MALAY = 'MALAY',
    MALAY_VFSC = 'MALAY_VFSC',
    NETELLER = 'NETELLER',
    NETELLER_FCS = 'NETELLER_FCS',
    NONE = '',
    PAGSMILE = 'PAG_FCS',
    PAY = 'PAYPAL',
    PAY_RETAILER = 'BRG_FCS',
    PHILIP = 'Philip',
    POLI = 'POLI',
    POLI_FCS = 'POLI_FCS',
    SKRILL = 'SKRILL',
    SKRILL_CYSEC = 'SKRILL_CYSEC',
    SKRILL_FCS = 'SKRILL_FCS',
    T365THB = 'T365THB',
    THAI = 'THAI',
    THAI_VFSC = 'THAI_VFSC',
    UPOP = 'UPOP',
    VN = 'VN',
    VN_VFSC = 'VN_VFSC'
}
